/*
 * YourXI Bespoke XI "Studio" layout (direction B)
 * --------------------------------------------------------------------------
 * window.YXIStudio. Figma fmRuxmJzd6EVJnmLq1USOJ node 26:1246.
 * Desktop: top bar, tool rail, tool panel, canvas (the print), inspector.
 * Phone: canvas fills the screen, bottom tab bar, tools open in a sheet
 * (half height, drag to full, swipe down to close). Tapping a shirt opens the
 * player in the inspector (desktop) or the sheet (phone) and the canvas moves
 * so the shirt stays visible above the sheet. CSS prefix: yxb-. studio.css is
 * injected from the same folder unless already linked. Holds no XI state.
 *
 * const st = YXIStudio.mount(rootEl, {
 *   tools: [{ id, label, icon, title, intro, tab,       // tab: true = in the phone tab bar (max 5)
 *             render(el, st), summary(st) -> string,    // panel content, short status beside the title
 *             inspect(el, st) }],                        // optional inspector while this tool is active
 *   startTool: 'inspire', playerTool: 'players',         // tab lit while a player sheet is open (phone)
 *   inspector(el, st),                                    // default inspector (nothing selected)
 *   title: "Untitled XI", onTitle(text, st),
 *   views: [['print','Print'],['wall','On your wall']], onView(id, st),
 *   hint: 'Tap a shirt to start blank',
 *   paperWidth: 440, slotSelector: '[data-slot]',
 *   onToolChange(id, prevId, st), onCanvasTap(slotId, slotEl, st),
 *   toolbar: { undo, redo, surprise, share, save },      // fn(st); missing = hidden
 *   price: '£XX.XX', priceDetail: '18 x 24 in, black frame',
 *   finalAction: { label: 'Add to cart', run(st) },
 *   storageKey: 'yxb',
 *   toolDetents: { order: 'top' }                         // phone: open this tool's sheet full screen, under the views toggle
 * });
 * st.canvasEl                       render the print here (SVG, width 100%); shirts carry data-slot="id"
 * st.openTool(id) / st.closeSheet() / st.activeTool()
 * st.openPlayer(slotId, render(el, st), {actions: [{id, label, icon, run}]}) / st.closePlayer() / st.selected()
 * st.setPrice(price, detail)  st.setTitle(t)  st.setHint(text|null)  st.setView(id)
 * st.setTool(name, {disabled, hidden})  st.refresh()  st.renderInspector()  st.rerender(toolId)
 * st.accordion(parentEl, {id, label, summary, open, render(el)}) -> {el, body, setSummary(t), setOpen(b)}
 * st.fit()  st.zoom(n)  st.isMobile()
 * st.toast(msg, {action: {label, run}, duration})
 * st.sheet(contentElOrHtml, {title, actions: [{label, primary, onClick(close)}], onClose}) -> {el, body, close()}
 * st.destroy()
 */
(function (root) {
  'use strict';

  var SRC = (document.currentScript && document.currentScript.src) || '';
  var MOBILE = '(max-width: 959px)';
  var uid = 0;

  function injectCss() {
    if (!SRC || document.querySelector('link[data-yxb], link[href*="studio.css"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.setAttribute('data-yxb', '');
    l.href = SRC.replace(/studio(\.min)?\.js(\?.*)?$/, 'studio.css');
    document.head.appendChild(l);
  }
  var store = {
    get: function (k) { try { return JSON.parse(root.localStorage.getItem(k)); } catch (e) { return null; } },
    set: function (k, v) { try { root.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  function mq(q) { return !!(root.matchMedia && root.matchMedia(q).matches); }
  function reduced() { return mq('(prefers-reduced-motion: reduce)'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function h(tag, attrs, html) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] == null || attrs[k] === false) continue;
      if (k === 'class') el.className = attrs[k]; else el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    if (html != null) el.innerHTML = html;
    return el;
  }
  function typing(t) { return t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)); }

  // Simple line icons, 24 grid, 1.7 stroke
  var A = 'class="yxb-i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var IC = {
    grid: '<svg ' + A + '><rect x="4" y="4" width="6.5" height="6.5"/><rect x="13.5" y="4" width="6.5" height="6.5"/><rect x="4" y="13.5" width="6.5" height="6.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5"/></svg>',
    users: '<svg ' + A + '><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.6-3.6 3.2-5.5 6.5-5.5s5.9 1.9 6.5 5.5"/><path d="M15.5 4.8a3.4 3.4 0 0 1 0 6.4"/><path d="M18 14.8c2 .7 3.2 2.4 3.5 5.2"/></svg>',
    pitch: '<svg ' + A + '><rect x="5" y="3" width="14" height="18"/><path d="M5 12h14"/><circle cx="12" cy="12" r="2.6"/><path d="M9 3v3h6V3M9 21v-3h6v3"/></svg>',
    shirt: '<svg ' + A + '><path d="M8.5 3.5 4 5.5 2.5 10l3 1.2V20.5h13V11.2l3-1.2L20 5.5l-4.5-2a3.5 3.5 0 0 1-7 0Z"/></svg>',
    sliders: '<svg ' + A + '><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/></svg>',
    type: '<svg ' + A + '><path d="M5 6.5V4.5h14v2M12 4.5v15M9 19.5h6"/></svg>',
    calendar: '<svg ' + A + '><rect x="3.5" y="5" width="17" height="15.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>',
    bag: '<svg ' + A + '><path d="M5 8h14l-1 12.5H6L5 8Z"/><path d="M9 10V6.5a3 3 0 0 1 6 0V10"/></svg>',
    undo: '<svg ' + A + '><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>',
    redo: '<svg ' + A + '><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg>',
    shuffle: '<svg ' + A + '><path d="M3 7h3.5c4.5 0 6.5 10 11 10H21"/><path d="M3 17h3.5c1.6 0 2.8-1.3 3.8-3M13.7 10c1-1.7 2.2-3 3.8-3H21"/><path d="m18 4 3 3-3 3M18 14l3 3-3 3"/></svg>',
    share: '<svg ' + A + '><path d="M12 3v12"/><path d="m7 8 5-5 5 5"/><path d="M5 13v8h14v-8"/></svg>',
    mail: '<svg ' + A + '><rect x="3" y="5" width="18" height="14"/><path d="m3 7 9 6 9-6"/></svg>',
    more: '<svg ' + A + '><circle cx="5" cy="12" r="1.2" fill="currentColor"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/><circle cx="19" cy="12" r="1.2" fill="currentColor"/></svg>',
    pen: '<svg ' + A + '><path d="M15 4.5 19.5 9 8.5 20H4v-4.5L15 4.5Z"/></svg>',
    close: '<svg ' + A + '><path d="M6 6l12 12M18 6 6 18"/></svg>',
    down: '<svg ' + A + '><path d="m6 9 6 6 6-6"/></svg>',
    plus: '<svg ' + A + '><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg ' + A + '><path d="M5 12h14"/></svg>',
    swap: '<svg ' + A + '><path d="M4 8h15l-4-4M20 16H5l4 4"/></svg>',
    trash: '<svg ' + A + '><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
    search: '<svg ' + A + '><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.5-4.5"/></svg>',
    gift: '<svg ' + A + '><rect x="3.5" y="8" width="17" height="4"/><path d="M5 12v8.5h14V12M12 8v12.5M12 8c-1-3-5-4-5-1.5S11 8 12 8Zm0 0c1-3 5-4 5-1.5S13 8 12 8Z"/></svg>',
    eye: '<svg ' + A + '><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>',
    check: '<svg ' + A + '><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    move: '<svg ' + A + '><path d="M12 3v18M3 12h18M12 3 9.5 5.5M12 3l2.5 2.5M12 21l-2.5-2.5M12 21l2.5-2.5M3 12l2.5-2.5M3 12l2.5 2.5M21 12l-2.5-2.5M21 12l-2.5 2.5"/></svg>',
    fit: '<svg ' + A + '><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>',
    logo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M8.5 3.5 4 5.5 2.5 10l3 1.2V20.5h13V11.2l3-1.2L20 5.5l-4.5-2a3.5 3.5 0 0 1-7 0Z"/></svg>'
  };
  function icon(n) { return IC[n] || (n && n.indexOf('<svg') === 0 ? n : IC.grid); }

  function mount(rootEl, o) {
    injectCss();
    o = o || {};
    var KEY = o.storageKey || 'yxb';
    var W0 = o.paperWidth || 440;
    var SLOT = o.slotSelector || '[data-slot]';
    var tools = (o.tools || []).slice();
    var tb = o.toolbar || {};
    var st = {};
    var id0 = 'yxb' + (++uid);
    var cleanups = [];
    var active = null;            // active tool id
    var sel = null;               // {id, el, render, actions}
    var sheetMode = null;         // phone: null | 'tool' | 'player'
    var detent = 'half';
    var zoomLevel = 1;
    var cur = { x: 0, y: 0, s: 1 };
    var modalOpen = 0;
    var toolBtns = {};

    rootEl.innerHTML = '';
    rootEl.classList.add('yxb');

    // ---------- Top bar ----------
    var top = h('header', { class: 'yxb-top' });
    // the exact site logo (modules/brand-logo.js), never rebuilt from text; drawn mark only if that file is missing
    top.appendChild(h('a', { class: 'yxb-brand', href: o.brandHref || '/', 'aria-label': 'YourXI home' },
      root.YXI_LOGO ? '<img class="yxb-logo" src="' + root.YXI_LOGO.black + '" alt="YourXI">' : IC.logo + 'YOUR<span>XI</span>'));
    var titleBtn = h('button', { class: 'yxb-title', type: 'button', 'aria-label': 'Rename this XI' }, '<span></span>' + IC.pen);
    top.appendChild(titleBtn);
    top.appendChild(h('div', { class: 'yxb-spacer' }));
    var bar = h('div', { class: 'yxb-tools', role: 'toolbar', 'aria-label': 'Your XI tools' });
    function tbtn(name, label, ic, iconOnly) {
      if (typeof tb[name] !== 'function') return null;
      var b = h('button', { class: iconOnly ? 'yxb-ibtn' : 'yxb-tbtn', type: 'button', 'data-tool': name, 'aria-label': label, title: label },
        icon(ic) + (iconOnly ? '' : '<span class="yxb-tl">' + esc(label) + '</span>'));
      b.addEventListener('click', function () { runTool(name); });
      bar.appendChild(b);
      tbState[name] = { btn: b, disabled: false, hidden: false };
      return b;
    }
    var tbState = {};
    tbtn('undo', 'Undo', 'undo', true);
    tbtn('redo', 'Redo', 'redo', true);
    if (tb.surprise || tb.share || tb.save) bar.appendChild(h('span', { class: 'yxb-div', 'aria-hidden': 'true' }));
    tbtn('surprise', 'Surprise me', 'shuffle');
    tbtn('share', 'Share', 'share');
    tbtn('save', 'Save my XI', 'mail');
    var moreBtn = h('button', { class: 'yxb-ibtn yxb-more', type: 'button', 'aria-label': 'More', title: 'More' }, IC.more);
    bar.appendChild(moreBtn);
    top.appendChild(bar);
    top.appendChild(h('span', { class: 'yxb-div', 'aria-hidden': 'true' }));
    var priceEl = h('div', { class: 'yxb-price', 'aria-live': 'polite' }, '<b></b><small></small>');
    top.appendChild(priceEl);
    var fa = o.finalAction || { label: 'Add to cart', run: function () {} };
    var cartBtn = h('button', { class: 'yxb-btn yxb-cart', type: 'button' }, esc(fa.label));
    var mcart = h('button', { class: 'yxb-mcart', type: 'button' }, '<b>' + esc(fa.label) + '</b><small></small>');
    top.insertBefore(mcart, bar);
    top.appendChild(cartBtn);
    cartBtn.addEventListener('click', function () { fa.run(st); });
    mcart.addEventListener('click', function () { fa.run(st); });
    rootEl.appendChild(top);

    // ---------- Rail, panel, stage, inspector, tabs ----------
    var rail = h('nav', { class: 'yxb-rail', 'aria-label': 'Tools' });
    var panel = h('aside', { class: 'yxb-panel', 'aria-label': 'Tool settings' });
    var panes = h('div', { class: 'yxb-panes' });
    panel.appendChild(panes);
    var stage = h('main', { class: 'yxb-stage', 'aria-label': 'Your print' });
    var sizer = h('div', { class: 'yxb-sizer' });
    var paper = h('div', { class: 'yxb-paper' });
    var selLayer = h('div', { class: 'yxb-sel', hidden: true }, '<div class="yxb-sel-box"></div>');
    sizer.appendChild(paper); sizer.appendChild(selLayer); stage.appendChild(sizer);
    var ctop = h('div', { class: 'yxb-canvas-top' });
    stage.appendChild(ctop);
    var viewsEl = null;
    if (o.views && o.views.length > 1) {
      viewsEl = h('div', { class: 'yxb-views', role: 'tablist', 'aria-label': 'Preview' });
      o.views.forEach(function (v, i) {
        var b = h('button', { class: 'yxb-view', type: 'button', role: 'tab', 'data-view': v[0], 'aria-selected': String(i === 0) }, esc(v[1]));
        b.addEventListener('click', function () { st.setView(v[0], true); });
        viewsEl.appendChild(b);
      });
      ctop.appendChild(viewsEl);
      ctop.hidden = !o.showViews;
    }
    var hint = h('div', { class: 'yxb-hint is-off', 'aria-hidden': 'true' });
    stage.appendChild(hint);
    var zoomEl = h('div', { class: 'yxb-zoom', role: 'group', 'aria-label': 'Zoom' },
      '<button type="button" data-z="-1" aria-label="Zoom out">' + IC.minus + '</button><button type="button" data-z="0" aria-label="Fit to screen">Fit</button><button type="button" data-z="1" aria-label="Zoom in">' + IC.plus + '</button>');
    stage.appendChild(zoomEl);
    zoomEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var d = Number(b.dataset.z);
      st.zoom(d === 0 ? 1 : Math.max(1, Math.min(2.5, zoomLevel + d * 0.5)));
    });
    var insp = h('aside', { class: 'yxb-insp', 'aria-label': 'Inspector' });
    var inspBody = h('div', { class: 'yxb-insp-body' });
    insp.appendChild(inspBody);
    var tabs = h('nav', { class: 'yxb-tabs', 'aria-label': 'Tools' });

    // phone sheet
    var msheet = h('section', { class: 'yxb-msheet', role: 'dialog', 'aria-modal': 'false', 'aria-label': 'Tool' });
    var grab = h('div', { class: 'yxb-msheet-grab', 'aria-hidden': 'true' });
    var mbody = h('div', { class: 'yxb-msheet-body' });
    // Keep the sheet where it was when a tap rebuilds its content. Tools like the kit maker redraw their controls on
    // every change; WebKit (iOS Safari, Instagram's in-app browser) clamps the scroll to 0 while the old content is
    // gone, so every tap jumped back to the top. A scroll that happens straight after a tap and wasn't a swipe is put back.
    (function keepScroll(el) {
      var saved = null, at = 0, swiping = false;
      var mark = function (e) {
        var t = e && e.target, typing = t && t.closest && t.closest('input[type=text], input[type=search], input:not([type]), textarea, select');
        saved = typing ? null : el.scrollTop; at = Date.now(); swiping = false;   // let the browser scroll a field into view
      };
      el.addEventListener('pointerdown', mark, true);
      el.addEventListener('touchstart', mark, { capture: true, passive: true });
      el.addEventListener('touchmove', function () { swiping = true; }, { capture: true, passive: true });
      el.addEventListener('wheel', function () { saved = null; }, { passive: true });
      var restore = function () {
        if (saved == null || swiping || Date.now() - at > 900) return;
        if (saved > 40 && el.scrollTop < saved - 40) el.scrollTop = saved;   // only an upward jump right after a tap, never a scroll the person made
      };
      el.addEventListener('scroll', restore, { passive: true });
      if (root.MutationObserver) new MutationObserver(function () { restore(); requestAnimationFrame(restore); }).observe(el, { childList: true, subtree: true });
      el._yxbKeep = { reset: function () { saved = null; } };
    })(mbody);
    var playerPane = h('div', { class: 'yxb-pane yxb-player', hidden: true });
    msheet.appendChild(grab); msheet.appendChild(mbody);

    rootEl.appendChild(rail); rootEl.appendChild(panel); rootEl.appendChild(stage); rootEl.appendChild(insp);
    rootEl.appendChild(msheet); rootEl.appendChild(tabs);
    var toasts = h('div', { class: 'yxb-toasts', role: 'status', 'aria-live': 'polite' });
    rootEl.parentNode.insertBefore(toasts, rootEl.nextSibling);
    var live = h('div', { class: 'yxb-sr', 'aria-live': 'polite' });
    rootEl.appendChild(live);

    // ---------- Tools ----------
    var T = {};
    tools.forEach(function (t) {
      var pane = h('section', { class: 'yxb-pane', 'data-tool': t.id, hidden: true, 'aria-labelledby': id0 + '-t-' + t.id });
      pane.innerHTML = '<div class="yxb-pane-head"><h2 id="' + id0 + '-t-' + t.id + '" tabindex="-1">' + esc(t.title || t.label) + '</h2><span class="yxb-pane-sum"></span></div>' +
        (t.intro ? '<p class="yxb-pane-intro">' + esc(t.intro) + '</p>' : '');
      var body = h('div', { class: 'yxb-pane-body' });
      pane.appendChild(body);
      panes.appendChild(pane);
      var rb = h('button', { class: 'yxb-tool', type: 'button', 'aria-pressed': 'false', 'aria-controls': id0 + '-t-' + t.id }, icon(t.icon) + '<span>' + esc(t.label) + '</span>');
      rb.addEventListener('click', function () { st.openTool(t.id, { user: true }); });
      rail.appendChild(rb);
      var tab = null;
      if (t.tab) {
        tab = h('button', { class: 'yxb-tab', type: 'button', 'aria-pressed': 'false', 'data-tool': t.id }, icon(t.icon) + '<span>' + esc(t.short || t.label) + '</span>');
        tab.addEventListener('click', function () {
          if (sheetMode === 'tool' && active === t.id) st.closeSheet(); else st.openTool(t.id, { user: true });
        });
        tabs.appendChild(tab);
      }
      T[t.id] = { def: t, pane: pane, body: body, sum: pane.querySelector('.yxb-pane-sum'), rail: rb, tab: tab, rendered: false };
    });
    toolBtns = T;

    // ---------- Responsive placement ----------
    var mobile = null;
    function place() {
      var m = mq(MOBILE);
      if (m === mobile) return;
      mobile = m;
      if (m) { mbody.appendChild(panes); mbody.appendChild(playerPane); }
      else {
        panel.appendChild(panes);
        playerPane.hidden = true;
        rootEl.classList.remove('has-sheet');
        msheet.classList.remove('is-open'); msheet.style.transform = '';
        sheetMode = null;
        Object.keys(T).forEach(function (k) { T[k].pane.hidden = k !== active; });
      }
      renderInspector();
      paintNav();
      layout(false);
    }
    st.isMobile = function () { return !!mobile; };

    // ---------- Tool switching ----------
    function renderTool(x) {
      if (x.rendered) return;
      x.rendered = true;
      if (typeof x.def.render === 'function') x.def.render(x.body, st);
      paintSum(x);
    }
    function paintSum(x) { var s = typeof x.def.summary === 'function' ? x.def.summary(st) : ''; x.sum.textContent = s || ''; }
    function paintNav() {
      Object.keys(T).forEach(function (k) {
        var x = T[k], on = k === active;
        x.rail.setAttribute('aria-pressed', String(on));
        if (x.tab) {
          var lit = mobile ? (sheetMode === 'tool' && on) || (sheetMode === 'player' && k === (o.playerTool || 'players')) : on;
          x.tab.setAttribute('aria-pressed', String(!!lit));
        }
      });
    }

    st.openTool = function (id, opts) {
      opts = opts || {};
      var x = T[id]; if (!x) return false;
      var prev = active;
      renderTool(x);
      if (prev !== id) {
        if (prev && T[prev]) T[prev].pane.hidden = true;
        x.pane.hidden = false;
        x.pane.classList.remove('is-in'); void x.pane.offsetWidth; x.pane.classList.add('is-in');
        active = id;
        panel.scrollTop = 0;
      }
      if (mobile && opts.sheet !== false) {
        if (sel) clearSel(false);
        playerPane.hidden = true;
        x.pane.hidden = false;
        openSheet('tool', opts.detent || (o.toolDetents && o.toolDetents[id]) || 'half');
        if (mbody._yxbKeep) mbody._yxbKeep.reset(); mbody.scrollTop = 0;
        msheet.setAttribute('aria-label', x.def.label);
        if (opts.user) focusLater(x.pane.querySelector('h2'));
      }
      if (prev !== id) {
        if (!sel || mobile) renderInspector();
        if (typeof o.onToolChange === 'function') o.onToolChange(id, prev, st);
        live.textContent = x.def.label;
      }
      paintNav();
      return true;
    };
    st.activeTool = function () { return active; };
    st.rerender = function (id) {
      Object.keys(T).forEach(function (k) {
        if (id && k !== id) return;
        var x = T[k]; x.body.innerHTML = ''; x.rendered = false;
        if (k === active) renderTool(x);
      });
    };

    // ---------- Inspector ----------
    function renderInspector() {
      if (mobile) { inspBody.innerHTML = ''; return; }
      inspBody.innerHTML = '';
      inspBody.classList.remove('is-in'); void inspBody.offsetWidth; inspBody.classList.add('is-in');
      if (sel && typeof sel.render === 'function') sel.render(inspBody, st);
      else {
        var t = active && T[active] && T[active].def;
        if (t && typeof t.inspect === 'function') t.inspect(inspBody, st);
        else if (typeof o.inspector === 'function') o.inspector(inspBody, st);
      }
    }
    st.renderInspector = renderInspector;

    // ---------- Selection / player ----------
    st.openPlayer = function (slotId, render, opts) {
      opts = opts || {};
      var el = paper.querySelector(SLOT.replace(/\]$/, '="' + String(slotId).replace(/"/g, '') + '"]')) || null;
      if (sel && sel.el) sel.el.classList.remove('yxb-is-selected');
      sel = { id: slotId, el: el, render: render, actions: opts.actions || [] };
      if (el) el.classList.add('yxb-is-selected');
      setHintVisible(false);
      if (mobile) {
        playerPane.innerHTML = '';
        if (typeof render === 'function') render(playerPane, st);
        Object.keys(T).forEach(function (k) { T[k].pane.hidden = true; });
        playerPane.hidden = false;
        if (mbody._yxbKeep) mbody._yxbKeep.reset(); mbody.scrollTop = 0;
        msheet.setAttribute('aria-label', opts.label || 'Player');
        openSheet('player', 'half');
        focusLater(playerPane.querySelector('h2,h3,[autofocus]'));
      } else {
        renderInspector();
      }
      paintSel(); paintNav();
      layout(true);
      return st;
    };
    st.closePlayer = function () { clearSel(true); };
    st.selected = function () { return sel ? sel.id : null; };
    function clearSel(relayout) {
      if (!sel) return;
      if (sel.el) sel.el.classList.remove('yxb-is-selected');
      sel = null;
      selLayer.hidden = true;
      setHintVisible(true);
      if (mobile && sheetMode === 'player') { st.closeSheet(); return; }
      renderInspector(); paintNav();
      if (relayout !== false) layout(true);
    }

    function paintSel() {
      if (!sel || !sel.el) { selLayer.hidden = true; return; }
      selLayer.hidden = false;
      var bars = selLayer.querySelector('.yxb-sel-bar');
      if (bars) bars.remove();
      if (sel.actions.length) {
        var b = h('div', { class: 'yxb-sel-bar', role: 'toolbar', 'aria-label': 'Shirt actions' });
        sel.actions.forEach(function (a) {
          var btn = h('button', { type: 'button', 'aria-label': a.label }, (a.icon ? icon(a.icon) : '') + '<span class="yxb-sel-l">' + esc(a.label) + '</span>');
          var born = Date.now();
          btn.addEventListener('click', function (e) { e.stopPropagation(); if (Date.now() - born < 300) return; a.run(sel ? sel.id : null, st); });
          b.appendChild(btn);
        });
        selLayer.appendChild(b);
      }
    }
    function natRect(el) {
      el = (el.querySelector && el.querySelector('.ring')) || el;   // size from the shirt, never the tap area
      var pr = paper.getBoundingClientRect(), er = el.getBoundingClientRect();
      var k = pr.width / W0 || 1;
      return { x: (er.left - pr.left) / k, y: (er.top - pr.top) / k, w: er.width / k, h: er.height / k };
    }

    // ---------- Canvas layout (transform only) ----------
    function sheetVisible() {
      if (!mobile || !sheetMode) return 0;
      var H = msheet.offsetHeight;
      return H - detentY(detent);
    }
    function detentY(d) {
      var H = msheet.offsetHeight;
      var avail = stage.clientHeight;
      if (isShort()) return 0;                         // short screens (200% zoom, landscape): every sheet opens full height
      if (d === 'max') return 0;                       // true full screen (the kit maker on phone)
      if (d === 'top') return topGap();                // full screen, just under the Print / On your wall toggle (Order, 19 Oct)
      if (d === 'full') {
        // tool sheets stop short of the top so some of the print always shows (o.keepPrint px, default 200)
        var keep = o.keepPrint == null ? 200 : o.keepPrint, skip = o.fullTools || ['inspire'];
        if (sheetMode === 'tool' && keep && skip.indexOf(active) < 0) return Math.max(0, Math.min(H - Math.round(avail * (sheetMode === 'player' ? 0.5 : 0.58)), H - avail + keep));
        return 0;
      }
      var half = Math.round(avail * (sheetMode === 'player' ? 0.5 : 0.58));
      return Math.max(0, H - half);
    }
    // 'top' detent: the sheet's top sits 4px under the views toggle (and over the print's top edge), so the toggle stays usable. Measured even while
    // the toggle is still hidden (it is shown a frame later), so the sheet moves once, without a jump.
    function topGap() {
      if (!viewsEl) return 0;
      var was = ctop.hidden; if (was) ctop.hidden = false;
      var b = ctop.offsetTop + ctop.offsetHeight;
      if (was) ctop.hidden = true;
      return Math.max(0, Math.round(stage.offsetTop + b + 4 - msheet.offsetTop));
    }
    function fullFor() { return sheetMode === 'tool' && o.toolDetents && o.toolDetents[active] === 'top' ? 'top' : 'full'; }
    function layout(anim) {
      var w = stage.clientWidth, hgt = stage.clientHeight;
      var H0 = paper.offsetHeight || W0 * 1.414;
      var x, y, s, sw = w, sh = hgt;
      var topPad = (viewsEl && !ctop.hidden) || hint.textContent ? (mobile ? 56 : 80) : (mobile ? 16 : 40);
      if (!mobile) {
        var sFit = Math.min((w - 80) / W0, (hgt - topPad - 40) / H0);
        s = sFit * zoomLevel;
        var pw = W0 * s, ph = H0 * s;
        sw = Math.max(w, pw + 80); sh = Math.max(hgt, ph + topPad + 40);
        x = (sw - pw) / 2;
        y = zoomLevel === 1 ? topPad + Math.max(0, (hgt - topPad - 40 - ph) / 2) : topPad;
      } else {
        var visTop = topPad, visBot = hgt - sheetVisible() - 12;
        var f = sel && sel.el ? natRect(sel.el) : null;
        if (f && sheetMode === 'player') {
          s = Math.min((w - 64) / W0, 1.4);
          var mid = visTop + Math.max(40, (visBot - visTop)) / 2 + 10;
          y = mid - (f.y + f.h / 2) * s;
          y = Math.min(y, visTop);
          y = Math.max(y, Math.min(visTop, visBot - H0 * s));
        } else if (sheetMode === 'tool' && active !== 'inspire' && o.bigPrintWithSheet !== false) {
          // a tool sheet is open: the print keeps its full width so shirts stay big enough to tap (44px+);
          // the part under the sheet is reached by scrolling the stage
          s = (w - 32) / W0;
          y = visTop;
          sh = Math.max(hgt, y + H0 * s + sheetVisible() + 16);
        } else {
          s = Math.min((w - 32) / W0, Math.max(80, visBot - visTop) / H0);
          y = visTop + Math.max(0, (visBot - visTop - H0 * s) / 2);
        }
        x = (w - W0 * s) / 2;
      }
      sizer.style.width = sw + 'px'; sizer.style.height = sh + 'px';
      rootEl.classList.toggle('stage-scrolls', mobile && sh > hgt + 1);
      if (mobile && sh <= hgt + 1) stage.scrollTop = 0;
      var doAnim = anim && !reduced();
      paper.classList.toggle('is-anim', !!doAnim);
      selLayer.classList.toggle('is-anim', !!doAnim);
      paper.style.width = W0 + 'px';
      paper.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + s + ')';
      cur = { x: x, y: y, s: s };
      try { rootEl.dispatchEvent(new CustomEvent('yxb:layout', { bubbles: true, detail: { s: s, x: x, y: y } })); } catch (e) {}
      if (sel && sel.el) {
        var r = natRect(sel.el);
        var pad = 4;
        selLayer.style.transform = 'translate3d(' + (x + r.x * s - pad) + 'px,' + (y + r.y * s - pad) + 'px,0)';
        var box = selLayer.firstChild;
        box.style.width = (r.w * s + pad * 2) + 'px'; box.style.height = (r.h * s + pad * 2) + 'px';
        var bar2 = selLayer.querySelector('.yxb-sel-bar');
        if (bar2) placeBar(bar2, x, y, s, r, pad);
      }
    }
    // put the shirt bar above, below, right or left of the selected shirt: the first spot that covers no other shirt
    function placeBar(bar, x, y, s, r, pad, compact) {
      bar.classList.toggle('is-compact', !!compact);
      var bw = bar.offsetWidth || 90, bh = bar.offsetHeight || 32;
      var BW = r.w * s + pad * 2, BH = r.h * s + pad * 2, ox = x + r.x * s - pad, oy = y + r.y * s - pad;
      var others = Array.prototype.filter.call(paper.querySelectorAll(SLOT), function (n) { return n !== sel.el; }).map(function (n) {
        var q = natRect((n.querySelector && n.querySelector('.inner')) || n); return { l: x + q.x * s, t: y + q.y * s, r: x + (q.x + q.w) * s, b: y + (q.y + q.h) * s };
      });
      var cands = [[BW / 2 - bw / 2, -bh - 6], [BW / 2 - bw / 2, BH + 6], [BW + 6, BH / 2 - bh / 2], [-bw - 6, BH / 2 - bh / 2], [BW / 2 - bw / 2, BH - bh - 2], [BW / 2 - bw / 2, 2]];   // last resort: inside its own box
      var W = stage.clientWidth;
      var fits = cands.filter(function (c) {
        var l = ox + c[0], t = oy + c[1];
        if (l < 4 || l + bw > Math.max(W, sizer.offsetWidth) - 4 || t < 4) return false;
        return !others.some(function (o) { return l < o.r && l + bw > o.l && t < o.b && t + bh > o.t; });
      });
      if (!fits.length && !compact) return placeBar(bar, x, y, s, r, pad, true);   // crowded: icon-only bar, try again
      var best = fits[0] || cands[cands.length - 1];
      bar.style.left = (best[0] + bw / 2) + 'px'; bar.style.top = (best[1] + bh) + 'px';   // the bar is drawn at translate(-50%,-100%)
    }
    st.fit = function () { zoomLevel = 1; layout(true); };
    st.zoom = function (z) {
      zoomLevel = z; layout(true);
      zoomEl.querySelector('[data-z="0"]').textContent = z === 1 ? 'Fit' : Math.round(z * 100) + '%';
    };

    // canvas taps
    paper.addEventListener('click', function (e) {
      var s = e.target.closest(SLOT);
      if (s && paper.contains(s)) {
        if (typeof o.onCanvasTap === 'function') o.onCanvasTap(s.getAttribute(SLOT.replace(/^\[|\]$/g, '').split('=')[0]), s, st);
        return;
      }
      if (sel) clearSel(true);
    });
    paper.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var s = e.target.closest(SLOT); if (!s) return;
      e.preventDefault(); s.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    });
    stage.addEventListener('click', function (e) { if (e.target === stage || e.target === sizer) { if (sel) clearSel(true); } });

    // ---------- Phone sheet ----------
    function isShort() { return mobile && window.innerHeight < 560; }
    function markSheet() { rootEl.classList.toggle('is-short', isShort()); rootEl.classList.toggle('sheet-player', sheetMode === 'player'); }
    function openSheet(mode, d) {
      var was = sheetMode;
      sheetMode = mode; detent = d || 'half'; markSheet();
      rootEl.classList.add('has-sheet');
      msheet.classList.add('is-open');
      if (!was) { msheet.style.transform = 'translate3d(0,100%,0)'; void msheet.offsetWidth; }
      msheet.style.transform = 'translate3d(0,' + detentY(detent) + 'px,0)';
      padBody();
      layout(true);
      if (detent === 'top') stage.scrollTop = 0;
    }
    // phone: snap the open sheet to 'full' or 'half' (e.g. the kit maker goes full screen)
    st.setDetent = function (d) { if (mobile && sheetMode) setDetent(d); };
    st.sheetEl = function () { return msheet; };
    st.closeSheet = function () {
      if (!mobile || !sheetMode) { if (sel) clearSel(true); return; }
      var wasPlayer = sheetMode === 'player';
      sheetMode = null; markSheet();
      msheet.style.transform = 'translate3d(0,100%,0)';
      msheet.classList.remove('is-open');
      rootEl.classList.remove('has-sheet');
      if (wasPlayer && sel) { if (sel.el) sel.el.classList.remove('yxb-is-selected'); sel = null; selLayer.hidden = true; setHintVisible(true); }
      paintNav(); layout(true);
      var t = active && T[active] && T[active].tab;
      if (t && msheet.contains(document.activeElement)) t.focus({ preventScroll: true });
    };
    function setDetent(d) { detent = d; msheet.style.transform = 'translate3d(0,' + detentY(d) + 'px,0)'; padBody(); layout(true); if (d === 'top') stage.scrollTop = 0; }
    // the part of the sheet below the screen edge: keep focused or scrolled-to items above it
    // the part of the sheet below the screen edge (half height) gets matching space at the end of the content, so the
    // last rows can always be scrolled into view above the tab bar
    function padBody() { var p = (sheetMode ? detentY(detent) : 0); mbody.style.scrollPaddingBottom = p + 'px'; mbody.style.setProperty('--yxb-detent-pad', (p ? p + 24 : 0) + 'px'); }

    // drag the grab bar or the pane header
    var drag = null;
    function dragStart(e) {
      if (!mobile || !sheetMode) return;
      if (e.target.closest('button,input,select,textarea,a')) return;
      drag = { y0: e.clientY, t0: detentY(detent), last: [[e.timeStamp, e.clientY]], id: e.pointerId, moved: false };
      msheet.classList.add('is-drag');
      try { e.target.setPointerCapture(e.pointerId); } catch (er) { /* fine */ }
    }
    function dragMove(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dy = e.clientY - drag.y0;
      if (Math.abs(dy) > 3) drag.moved = true;
      var t = drag.t0 + dy;
      if (t < 0) t = t / 3; // rubber band above full
      msheet.style.transform = 'translate3d(0,' + t + 'px,0)';
      drag.last.push([e.timeStamp, e.clientY]); if (drag.last.length > 5) drag.last.shift();
    }
    function dragEnd(e) {
      if (!drag || e.pointerId !== drag.id) return;
      msheet.classList.remove('is-drag');
      var a = drag.last[0], b = drag.last[drag.last.length - 1];
      var v = (b[1] - a[1]) / Math.max(1, b[0] - a[0]); // px per ms
      var t = drag.t0 + (e.clientY - drag.y0);
      var proj = t + v * 160;
      var H = msheet.offsetHeight, half = detentY('half');
      var moved = drag.moved; drag = null;
      var full = fullFor();
      if (!moved) { if (e.target.closest('.yxb-msheet-grab')) setDetent(detent === 'half' ? full : 'half'); else setDetent(detent); return; }
      var opts = [[full, full === 'top' ? detentY('top') : 0], ['half', half], ['close', H]];
      var best = opts.reduce(function (p, c) { return Math.abs(c[1] - proj) < Math.abs(p[1] - proj) ? c : p; });
      if (best[0] === 'close') st.closeSheet(); else setDetent(best[0]);
    }
    [grab, mbody].forEach(function (n) {
      n.addEventListener('pointerdown', function (e) {
        if (n === mbody && !e.target.closest('.yxb-pane-head, .yxb-player-head')) return;
        dragStart(e);
      });
    });
    msheet.addEventListener('pointermove', dragMove);
    msheet.addEventListener('pointerup', dragEnd);
    msheet.addEventListener('pointercancel', dragEnd);
    // sheet height changes only with the handle (drag or tap); scrolling the body just scrolls

    function focusLater(el) {
      if (!el) return;
      setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) { /* gone */ } }, 40);
    }

    // ---------- Hint, views, title ----------
    var hintText = o.hint || '';
    function setHintVisible(v) { hint.classList.toggle('is-off', !(v && hintText && !sel)); }
    st.setHint = function (t) { hintText = t || ''; if (t) hint.textContent = t; setHintVisible(!!t); layout(false); };
    st.setView = function (id, user) {
      if (!viewsEl) return;
      ctop.hidden = false;
      Array.prototype.forEach.call(viewsEl.children, function (b) { b.setAttribute('aria-selected', String(b.dataset.view === id)); });
      paper.classList.toggle('is-bare', id !== (o.views[0] && o.views[0][0]));
      if (user && typeof o.onView === 'function') o.onView(id, st);
      if (user && mobile && sheetMode === 'tool' && detent === 'top' && id === (o.views[0] && o.views[0][0])) setDetent('half');
      layout(false);
    };
    st.showViews = function (v) { if (viewsEl) { ctop.hidden = !v; layout(true); } };

    var titleText = o.title || 'Untitled XI';
    function paintTitle() { titleBtn.firstChild.textContent = titleText; }
    st.setTitle = function (t) { titleText = t || 'Untitled XI'; paintTitle(); };
    titleBtn.addEventListener('click', function () {
      var inp = h('input', { class: 'yxb-title-input', type: 'text', maxlength: '40', 'aria-label': 'Name of this XI' });
      inp.value = titleText;
      titleBtn.hidden = true; titleBtn.parentNode.insertBefore(inp, titleBtn);
      // character counter (16 Oct): the title stops at 40, so show it
      var cnt = h('span', { class: 'yxb-title-count', 'aria-live': 'polite' }); inp.after(cnt);
      function cntUp() { cnt.textContent = inp.value.length + '/40'; } inp.addEventListener('input', cntUp); cntUp();
      inp.focus(); inp.select();
      var done = false;
      function commit(keep) {
        if (done) return; done = true;
        if (keep) { var v = inp.value.trim(); if (!(o.onTitle && o.onTitle(v, st) === false)) titleText = v || 'Untitled XI'; }
        inp.remove(); cnt.remove(); titleBtn.hidden = false; paintTitle(); titleBtn.focus();
      }
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') commit(true); if (e.key === 'Escape') commit(false); });
      inp.addEventListener('blur', function () { commit(true); });
    });
    paintTitle();

    // ---------- Toolbar ----------
    function runTool(n) { var t = tbState[n]; if (!t || t.disabled || t.hidden) return; tb[n](st); }
    st.setTool = function (n, s) {
      var t = tbState[n]; if (!t) return;
      if (s.disabled != null) { t.disabled = !!s.disabled; t.btn.setAttribute('aria-disabled', String(t.disabled)); }
      if (s.hidden != null) { t.hidden = !!s.hidden; t.btn.hidden = t.hidden; }
    };
    st.setTool('undo', { disabled: true }); st.setTool('redo', { disabled: true });

    moreBtn.addEventListener('click', function () {
      var list = h('ul', { class: 'yxb-menu' });
      tools.filter(function (t) { return !t.tab; }).forEach(function (t) {
        var x = T[t.id];
        var li = h('li'), b = h('button', { type: 'button' }, icon(t.icon) + '<span>' + esc(t.label) + '</span><small>' + esc(typeof t.summary === 'function' ? (t.summary(st) || '') : '') + '</small>');
        b.addEventListener('click', function () { m.close(); setTimeout(function () { st.openTool(t.id, { user: true }); }, 60); });
        li.appendChild(b); list.appendChild(li); void x;
      });
      [['surprise', 'Surprise me', 'shuffle'], ['share', 'Share', 'share'], ['save', 'Email me my XI', 'mail'], ['title', 'Rename this XI', 'pen']].forEach(function (a) {
        if (a[0] !== 'title' && (!tbState[a[0]] || tbState[a[0]].hidden)) return;
        var li = h('li'), b = h('button', { type: 'button' }, icon(a[2]) + '<span>' + esc(a[1]) + '</span>' + (a[0] === 'title' ? '<small>' + esc(titleText) + '</small>' : ''));
        b.addEventListener('click', function () {
          m.close();
          if (a[0] === 'title') renameSheet(); else runTool(a[0]);
        });
        li.appendChild(b); list.appendChild(li);
      });
      var m = st.sheet(list, { title: 'More' });
    });
    function renameSheet() {
      var wrap = h('div', null, '<label class="yxb-sr" for="' + id0 + '-rn">Name</label>');
      var inp = h('input', { id: id0 + '-rn', type: 'text', maxlength: '40', autofocus: '', enterkeyhint: 'done', class: 'yxb-rename-input', style: 'margin:0;width:100%;height:48px;font-size:16px' });
      inp.value = titleText === 'Untitled XI' ? '' : titleText; wrap.appendChild(inp);
      var note = h('p', { class: 'yxb-rename-note' }, '<span>' + esc(typeof o.renameHint === 'function' ? o.renameHint() : '') + '</span><span class="yxb-rename-count"></span>');
      wrap.appendChild(note);
      function count() { note.lastChild.textContent = inp.value.length + '/40'; }
      inp.addEventListener('input', count); count();
      function saveIt(close) { var v = inp.value.trim(); if (o.onTitle && o.onTitle(v, st) === false) return; titleText = v || 'Untitled XI'; paintTitle(); close(); }
      var dlg = st.sheet(wrap, { title: 'Rename this XI', actions: [{ label: 'Cancel' }, { label: 'Save', primary: true, onClick: saveIt }] });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); saveIt(dlg.close); } });
      setTimeout(function () { inp.focus(); inp.select(); }, 60);
    }

    function onKey(e) {
      if (modalOpen) return;
      var mod = e.metaKey || e.ctrlKey;
      if (e.key === 'Escape' && !typing(e.target)) {
        if (mobile && sheetMode) { st.closeSheet(); return; }
        if (sel) { clearSel(true); return; }
      }
      if (!mod || typing(e.target)) return;
      var k = e.key.toLowerCase();
      if (k === 'z' && !e.shiftKey) { e.preventDefault(); runTool('undo'); }
      else if ((k === 'z' && e.shiftKey) || k === 'y') { e.preventDefault(); runTool('redo'); }
    }
    document.addEventListener('keydown', onKey);
    cleanups.push(function () { document.removeEventListener('keydown', onKey); });

    // ---------- Price ----------
    st.setPrice = function (p, d) {
      priceEl.firstChild.textContent = p || ''; priceEl.lastChild.textContent = d || '';
      mcart.lastChild.textContent = p || '';
    };
    st.setPrice(o.price, o.priceDetail);

    // ---------- Refresh ----------
    st.refresh = function () {
      Object.keys(T).forEach(function (k) { if (T[k].rendered) paintSum(T[k]); });
      if (sel && sel.id != null) {
        var el = paper.querySelector(SLOT.replace(/\]$/, '="' + String(sel.id).replace(/"/g, '') + '"]'));
        if (el !== sel.el) { if (el) el.classList.add('yxb-is-selected'); sel.el = el; }
        paintSel();
      }
      layout(false);
    };

    // ---------- Accordion helper ----------
    var accState = store.get(KEY + ':acc') || {};
    st.accordion = function (parent, a) {
      var open = accState[a.id] != null ? !!accState[a.id] : !!a.open;
      var bid = id0 + '-a-' + a.id + (++uid);
      var el = h('div', { class: 'yxb-acc' });
      var btn = h('button', { class: 'yxb-acc-btn', type: 'button', 'aria-expanded': String(open), 'aria-controls': bid + 'b', id: bid },
        '<span>' + esc(a.label) + '</span><span class="yxb-acc-sum">' + esc(a.summary || '') + '</span>' + IC.down);
      var body = h('div', { class: 'yxb-acc-body', id: bid + 'b', role: 'region', 'aria-labelledby': bid, hidden: !open });
      el.appendChild(btn); el.appendChild(body); parent.appendChild(el);
      var rendered = false;
      function setOpen(v) {
        open = v; btn.setAttribute('aria-expanded', String(v)); body.hidden = !v;
        if (v && !rendered && a.render) { rendered = true; a.render(body); }
        if (v) { body.classList.remove('yxb-pane'); body.style.animation = 'yxb-fade .12s linear both'; }
        accState[a.id] = v; store.set(KEY + ':acc', accState);
      }
      btn.addEventListener('click', function () { setOpen(!open); });
      if (open && a.render) { rendered = true; a.render(body); }
      return { el: el, body: body, setOpen: setOpen, setSummary: function (t) { btn.querySelector('.yxb-acc-sum').textContent = t || ''; } };
    };

    // ---------- Toast ----------
    var toastEl = null, toastT = null;
    st.toast = function (msg, opts) {
      opts = opts || {};
      if (toastEl) toastEl.remove();
      clearTimeout(toastT);
      var t = h('div', { class: 'yxb-toast' }, '<span>' + esc(msg) + '</span>');
      if (opts.action) {
        var b = h('button', { type: 'button' }, esc(opts.action.label));
        b.addEventListener('click', function () { opts.action.run(st); hide(); });
        t.appendChild(b);
      }
      toasts.appendChild(t); toastEl = t;
      requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('is-on'); }); });
      function hide() { t.classList.remove('is-on'); setTimeout(function () { t.remove(); if (toastEl === t) toastEl = null; }, 240); }
      toastT = setTimeout(hide, opts.duration || (opts.action ? 5000 : 2600));
      return { close: hide };
    };

    // ---------- Modal sheet ----------
    st.sheet = function (content, opts) {
      opts = opts || {};
      var tid = id0 + '-d' + (++uid);
      var last = document.activeElement;
      var layer = h('div', { class: 'yxb-layer' });
      var scrim = h('div', { class: 'yxb-scrim', 'aria-hidden': 'true' });
      var box = h('div', { class: 'yxb-dlg', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': tid });
      var head = h('div', { class: 'yxb-dlg-head' });
      var ttl = h('h2', { id: tid, tabindex: '-1' }, esc(opts.title || ''));
      var x = h('button', { class: 'yxb-ibtn', type: 'button', 'aria-label': 'Close' }, IC.close);
      head.appendChild(ttl); head.appendChild(x);
      var body = h('div', { class: 'yxb-dlg-body' });
      if (typeof content === 'string') body.innerHTML = content; else if (content) body.appendChild(content);
      box.appendChild(head); box.appendChild(body);
      var api;
      if (opts.actions && opts.actions.length) {
        var ft = h('div', { class: 'yxb-dlg-foot' });
        opts.actions.forEach(function (a) {
          var b = h('button', { class: 'yxb-btn' + (a.primary ? '' : ' yxb-btn--ghost'), type: 'button' }, esc(a.label));
          b.addEventListener('click', function () { a.onClick ? a.onClick(api.close) : api.close(); });
          ft.appendChild(b);
        });
        box.appendChild(ft);
      }
      layer.appendChild(scrim); layer.appendChild(box);
      document.body.appendChild(layer);
      modalOpen++;
      rootEl.setAttribute('inert', '');
      requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('is-open'); }); });
      focusLater(box.querySelector('[autofocus]') || (!mobile && body.querySelector('input,textarea,select')) || ttl);
      var closed = false;
      function close() {
        if (closed) return; closed = true;
        layer.classList.remove('is-open');
        document.removeEventListener('keydown', key, true);
        modalOpen--;
        if (!modalOpen) rootEl.removeAttribute('inert');
        setTimeout(function () { layer.remove(); }, reduced() ? 0 : 360);
        if (last && last.focus) try { last.focus({ preventScroll: true }); } catch (e) { /* gone */ }
        if (opts.onClose) opts.onClose();
      }
      function key(e) {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(box.querySelectorAll('button,[href],input,select,textarea'), function (n) { return !n.disabled && n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
      document.addEventListener('keydown', key, true);
      var born = Date.now();
      x.addEventListener('click', close); scrim.addEventListener('click', function () { if (Date.now() - born > 300) close(); });
      api = { el: box, body: body, close: close };
      return api;
    };

    st.destroy = function () {
      cleanups.forEach(function (f) { f(); });
      document.querySelectorAll('.yxb-layer').forEach(function (n) { n.remove(); });
      toasts.remove();
      rootEl.innerHTML = ''; rootEl.classList.remove('yxb', 'has-sheet'); rootEl.removeAttribute('inert');
    };

    // ---------- Observers ----------
    if ('ResizeObserver' in root) {
      var ro = new ResizeObserver(function () { place(); layout(false); });
      ro.observe(stage); ro.observe(paper);
      cleanups.push(function () { ro.disconnect(); });
    }
    function onResize() { markSheet(); place(); if (mobile && sheetMode) msheet.style.transform = 'translate3d(0,' + detentY(detent) + 'px,0)'; layout(false); }
    root.addEventListener('resize', onResize);
    cleanups.push(function () { root.removeEventListener('resize', onResize); });

    st.el = rootEl;
    st.canvasEl = paper;
    st.icons = IC;
    st.tools = tools;

    if (hintText) { hint.textContent = hintText; setHintVisible(true); }
    place();
    st.openTool(o.startTool || (tools[0] && tools[0].id), { sheet: !!o.openSheetOnStart });
    layout(false);
    return st;
  }

  root.YXIStudio = { mount: mount, version: '1.0.0' };
})(window);
